import { render, staticRenderFns } from "./GravarRegistroCobrancaDialog.vue?vue&type=template&id=141ecc49&"
import script from "./GravarRegistroCobrancaDialog.vue?vue&type=script&lang=js&"
export * from "./GravarRegistroCobrancaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports